<template>
    <div class="schedule">
        <h6 class="title-section">{{$t('material.title')}}</h6>
        <!-- <h4 class="sub-title text-left"><span>{{$t('material.sub-title')}}</span></h4> -->
        <div class="send-request">
            <img src="@/assets/img/materials.png" style="margin-left: -30px;margin-right: 34px; align-self: flex-start;"/>
            <div class="w-100" id="contentBreadcrumb">

                <template v-if="!showDropdown">
                    <b-breadcrumb  v-if="itemsBreadCrumb.length >1"  style="margin-top: -1px;border-bottom: 1px solid #b7b8bd;" class="mb-0 pb-2">
                        <b-breadcrumb-item :id="'itemBreadcrumb_'+index" @click="changeLocalFile(index == itemsBreadCrumb.length - 1 ? '#' : items.href)"
                        :class="index == itemsBreadCrumb.length - 1 ? 'active' : ''"
                        v-for="(items,index) in itemsBreadCrumb" :key="index">{{index ==0 ? $t('material.title'):items.text}}
                            <b-tooltip custom-class="nameItem" :target="'itemBreadcrumb_'+index" :ref="'toolTipItem'">
                                {{index ==0? $t('material.title'):items.text}}
                            </b-tooltip>
                        </b-breadcrumb-item>
                    </b-breadcrumb>
                </template>
                <b-table hover :items="itemsTable" :busy="isBusy" :fields="fields" :show-empty="true" id="tableMaterial"
                :tbody-transition-props="transProps" style="white-space: pre-line;" :empty-text="$t('reusables.empty-text')">
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> {{$t('ClassRequest.Loading')}}...</strong>
                        </div>
                    </template>
                    <template #cell(fileName)="data">
                         <div class="d-flex">
                            <icon name="file" class="mr-3"/>
                            <p>{{data.value}}</p>
                        </div>
                    </template>
                    <template #cell(urlFile)="data">
                        <div>
                            <a :href="data.value" style="cursor: pointer;" target="_blank" class="link" >{{data.value}}</a>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
        <b-modal v-model="isModalShare" id="modalClipboard" centered hide-footer>
            <template #modal-header="{ close }">
                <img class="close" src="@/assets/img/close_red.png" @click="close()">
                <h5>{{$t('material.modal-clipboard.label')}}</h5>
            </template>
            <b-form-group   class="mt-4">
                <b-form-input readonly ref="inputURL" id="inputURL" v-model="modelUrlShare" @click="CopyUrl()"></b-form-input>
                <b-tooltip target="inputURL" placement="top" ref="showTooltipURL" triggers="focus">
                {{$t('material.textTooltip')}}
                </b-tooltip>
            </b-form-group>
            <div class="text-center">
                <b-button variant="primary" @click="CopyUrl()">{{$t('material.modal-clipboard.button')}}</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import * as tools from '@/assets/js/tools.js';
import axios from 'axios';

export default {
    data(){
        return {
            subject: 0,
            urlShare: "",
            resourceApi: this.$store.state.is_teacher ? 'PersonsTeachers' : 'PersonsStudents',
            pathBase: "/materials",
            extensionsPlay: [".mp3", ".mp4"],
            isBusy: false,
            transProps: { name: 'flip-list' },
            fields: [
                {key: 'fileName', label: this.$t('material.table-th.name'), thStyle:{width:"60%"}},
                {key: 'urlFile', label: this.$t('material.table-th.url'), thStyle:{width:"40%",textAlign:"center !important"}},
            ],
            isModalShare: false,
            itemsTable: [],
            flagFirstPath: true,
            itemsBreadCrumb: [],

            itemsInsideDropdown:[],
            pathNameLenght:0,
            showDropdown: false,
            modelUrlShare:'',
            counterCollapse:0,
            counterLastItems:0
        }
    },
    computed: {
        collapseBreadCrumbs() {
            if(this.itemsBreadCrumb.length >= this.counterLastItems) {
                let counter = this.itemsBreadCrumb.length
                let arr = this.itemsBreadCrumb.slice(1, (counter - this.counterLastItems))
                return arr
            }
            return []
        },
    },
    created(){
        this.itemsBreadCrumb = [];
        this.GetMaterials();
        this.screenDimension();
    },
    mounted(){
        this.$nextTick(function () {
            tools.imgToSvg()
        })
    },
    watch:{
        $route (to, from){
            this.GetMaterials()
        },
        isModalShare(val){
            this.$root.$on('bv::modal::show', (bvEvent, modalClipboard) => {
                this.modelUrlShare = window.location.href
            })
        },
        itemsBreadCrumb(val) {
            this.showDropdown = val.length - 1 > this.counterLastItems
        },
    },
    methods: {
        changeLocalFile(ruta){
            this.$router.push('/materials'+ruta.split('/materials')[1])
        },
        screenDimension(){
            let windowWidth = window.innerWidth
            if(windowWidth <= 1300){
                this.counterLastItems=2;
            }else if (windowWidth <= 1600){
                this.counterLastItems=4;
            }else if (windowWidth <= 1800){
                this.counterLastItems=5;
            }else{
                this.counterLastItems=6;
            }
        },
        validTextOverflow(index,value){
            let textItem = document.querySelector("#itemBreadcrumb_"+index+" a")
            console.log(textItem.offsetWidth < textItem.scrollWidth)
                if(textItem.offsetWidth < textItem.scrollWidth ){
                    if(value===null){
                        this.$refs['toolTipItem'][index].$emit('enable')
                    }
                    else this.$refs['toolTipItem'][value].$emit('enable')
                }
        },
        GetMoreMaterials(pathName){
            this.pathNameLenght = pathName.length
            this.$router.push(`${window.location.pathname}${window.location.pathname.endsWith('/') ? "" : "/" }${pathName}`);
            this.GetMaterials();
        },
        //GH => Codificar URL
        GetPathName(){
            let path = window.location.pathname.replace(this.pathBase, "").replace("/", "");
            if(path && !path.endsWith('/')) path+='/';
            return decodeURI(path);
        },
        GetMaterials(){
            this.isBusy = true;
            this.itemsBreadCrumb = [];
            this.itemsInsideDropdown = [];
            let params = {
                flagLenguage: this.$store.state.is_teacher ? false :  localStorage.getItem('lang') == "es" ? true : false,
                personId : this.$store.state.user.id,
                pathName : this.GetPathName(),
                groupId: this.$store.state.group_id
            };

            baseInstanceAxios
                .get(`${this.apiURL}/resources/${this.resourceApi}/GetMaterials`, {params})
                .then(response => {
                    if(response.data.message){
                        //this.$router.push(`materials/${response.data.message}`);
                        this.$router.push(`${response.data.message}`);
                    }
                    this.itemsTable = response.data.list;
                    this.isBusy = false;
                    this.$nextTick(function () {
                        tools.imgToSvg()
                    })
                });
                
                    
        },
        DownloadMaterial(fileName){
            let pathName = this.GetPathName() + fileName;
            pathName = encodeURIComponent(pathName);

            let headers = { responseType: "blob"};
            let flagLenguage= this.$store.state.is_teacher ? false :  localStorage.getItem('lang') == "es" ? true : false;
            baseInstanceAxios
                .get(`${this.apiURL}/resources/${this.resourceApi}/DownloadFile?flagLenguage=${flagLenguage}&personId=${this.$store.state.user.id}&pathName=${pathName}&groupId=${this.$store.state.group_id}`, headers)
                .then((response) => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([response.data]));
                    link.setAttribute('download', `${fileName}`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(() =>{});
        },
        ViewMaterial(urlMaterial){
            window.open(urlMaterial, '_blank');
        },
        CopyUrl(){
            try {
                let inputURL = document.getElementById('inputURL');
                inputURL.focus();
                inputURL.select();
                document.execCommand('copy');
                this.$refs.showTooltipURL.$emit('open')
                setTimeout(() => {
                    this.$refs.showTooltipURL.$emit('close')
                }, 1500);
            } catch (err) {
                console.error('Fallback:', err);
            }
        }
    }
}
</script>